import { ButtonHTMLAttributes, FC } from 'react';
import classnames from 'classnames';

import styles from './Button.module.scss';

interface Props {
  dataGtmClick?: string;
  dataTestId?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  outline?: boolean;
  shadow?: boolean;
  size?: 'large' | 'normal';
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  variant?: 'primary' | 'secondary';
}

const Button: FC<Props> = ({
  children,
  dataGtmClick,
  dataTestId,
  fullWidth,
  onClick,
  shadow = false,
  size = 'normal',
  disabled = false,
  outline = false,
  type = 'button',
  variant = 'primary',
}) => (
  <button
    className={classnames(styles.button, {
      [styles['full-width']]: fullWidth,
      [styles.large]: size === 'large',
      [styles.outline]: outline,
      [styles.shadow]: shadow,
      [styles[variant]]: variant,
    })}
    data-gtm-click={dataGtmClick}
    data-test-id={dataTestId}
    disabled={Boolean(!onClick) || disabled}
    onClick={onClick}
    type={type}
  >
    {children}
  </button>
);

export type { Props as ButtonProps };
export default Button;
